export default function download(response, fileName) {
  // 用户环境信息
  const uA = window.navigator.userAgent
  // 判断是不是ie浏览器 不考虑兼容可以删除
  const isIE =
    /msie\s|trident\/|edge\//i.test(uA) &&
    !!(
      'uniqueID' in document ||
      'documentMode' in document ||
      'ActiveXObject' in window ||
      'MSInputMethodContext' in window
    )
  //
  if (!fileName) {
    fileName = response.headers
      .get('Content-Disposition')
      .split(';')[1]
      .split("filename*=UTF-8''")[1]
    const fileNameUnicode = response.headers
      .get('Content-Disposition')
      .split('filename*=')[1]
    if (fileNameUnicode) {
      // 当存在 filename* 时，取filename* 并进行解码（为了解决中文乱码问题）
      fileName = decodeURIComponent(fileNameUnicode.split("''")[1])
    }
  }
  if (isIE) {
    navigator.msSaveBlob(response, fileName)
    // 可能会出现有body的情况
    // navigator.msSaveBlob(response.body, fileName)
  } else {
    let binaryData = []
    binaryData.push(response)
    // 响应文件 文件流做为路径
    const objectUrl = window.URL.createObjectURL(new Blob(binaryData))
    // 可能会出现有body的情况
    // 创建a标签 达到下载效果
    const a = document.createElement('a')
    a.addEventListener('click', () => {
      a.download = fileName
      a.href = objectUrl
    })
    const e = document.createEvent('MouseEvents')
    e.initEvent('click', false, false)
    a.dispatchEvent(e)
  }
}